<template>
  <div>
    <modal name="create-post-modal"
           :click-to-close="false"
           :width="750"
           height="auto"
           class="select-group-modal modal-custom"
           transition="easeInOut"
           @before-open="beforeOpened"
           @before-close="beforeClosed"
    >
      <vue-element-loading :active="show" spinner="bar-fade-scale"/>
      <div v-if="!isEditingMedia && !isTagUser && !isSelectingBackground">
        <md-card class="modal-header-custom">
          <template>
            <md-dialog-title v-if="isPoll">
              <div class="poll-header">
              <span class="material-icons cursor-pointer"
                    @click="changeToPollPopup('cancel')">keyboard_backspace</span>
                <span class="neutral_1 heading-500 text-header-modal">Tạo bình chọn</span>
              </div>
            </md-dialog-title>
            <md-dialog-title v-else>
              <span class="neutral_1 heading-500 text-header-modal" v-if="this.selectedGroup == ''">Chọn nhóm</span>
              <span class="neutral_1 heading-500 text-header-modal" v-else>Tạo bài viết</span>
              <span class="material-icons float-right cursor-pointer"
                    @click="$modal.hide('create-post-modal')">close</span>
            </md-dialog-title>
          </template>
        </md-card>
        <md-card-content class="custom-scroll-bar-2">
          <template>
            <div v-if="selectedGroup == ''">
              <div class="input-container">
                <input class="input-search-field" type="text" placeholder="Tìm kiếm nhóm để đăng" name="search-group"
                       v-model="searchInput" @keyup="getGroups">
                <i class="fa fa-search search-icon"></i>
              </div>
              <div class="custom-scroll-bar-2" style="overflow-y: auto; max-height: 700px">
                <div class="group-section company-wall-group-container" v-if="organizationGroups.length !== 0">
                  <div class="heading-500">Tổ chức</div>
                  <div name="title" v-for="(group, i) in organizationGroups" :key="i"
                       class="group-container  cursor-pointer"
                       @click="selectGroup('group', group)">
                    <div class="group-image-wrapper">
                      <md-icon>
                        <md-image style="height: 100%; width: 100%">
                          <img :src="group.avatar_url ? group.avatar_url : groupImageDefault"
                               class="group-image"
                          >
                        </md-image>
                      </md-icon>
                    </div>
                    <div class="group-info-wrapper">
                <span class="text-400-medium">
                  {{ group.name }}
                </span>
                      <div class="text-300-default ">
                        <span>{{ group.member_count }} thành viên</span>
                        <span> ・ </span>
                        <span :class="group.classColor">{{ group.typeName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="group-section work-group-container" v-if="workGroups.length !== 0">
                  <div class="heading-500">Nhóm làm việc</div>
                  <div name="title" v-for="(group, i) in workGroups" :key="'a' + i"
                       class="group-container  cursor-pointer"
                       @click="selectGroup('group', group)">
                    <div class="group-image-wrapper">
                      <md-icon>
                        <md-image style="height: 100%; width: 100%">
                          <img :src="group.avatar_url ? group.avatar_url : groupImageDefault"
                               class="group-image"
                          >
                        </md-image>
                      </md-icon>
                    </div>
                    <div class="group-info-wrapper">
                <span class="text-400-medium">
                  {{ group.name }}
                </span>
                      <div class="text-300-default ">
                        <span>{{ group.member_count }} thành viên</span>
                        <span> ・ </span>
                        <span :class="group.classColor">{{ group.typeName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="group-section joined-group-container" v-if="joinedGroups.length !== 0">
                  <div class="heading-500">Nhóm mà bạn đang tham gia</div>
                  <div name="title" v-for="(group, i) in joinedGroups" :key="'b' + i"
                       class="group-container  cursor-pointer"
                       @click="selectGroup('group', group)">
                    <div class="group-image-wrapper">
                      <md-icon>
                        <md-image style="height: 100%; width: 100%">
                          <img :src="group.avatar_url ? group.avatar_url : groupImageDefault"
                               class="group-image"
                          >
                        </md-image>
                      </md-icon>
                    </div>
                    <div class="group-info-wrapper">
                <span class="text-400-medium">
                  {{ group.name }}
                </span>
                      <div class="text-300-default ">
                        <span>{{ group.member_count }} thành viên</span>
                        <span> ・ </span>
                        <span :class="group.classColor">{{ group.typeName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="group-section">
                  <div class="heading-500">Dòng thời gian của bạn</div>
                  <div name="title" class="group-container cursor-pointer" @click="selectGroup('me', null)">
                    <div class="group-image-wrapper">
                      <md-icon>
                        <md-image style="height: 100%; width: 100%">
                          <img
                              :src=user.avatar_url
                              class="group-image avatar"
                          >
                        </md-image>
                      </md-icon>
                    </div>
                    <div class="group-info-wrapper">
                <span class="text-400-medium">
                  {{ user.fullname }}
                </span>
                      <div class="text-300-default ">
                        <span>{{ userPosition ? userPosition.name : 'N/A' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <md-list-item class="pt-0px user-group-info" v-if="!isPoll">
                <md-avatar>
                  <img class="avatar" :src="user.avatar_url?user.avatar_url:'/img/profile/avatar.png'">
                </md-avatar>
                <div class="md-list-item-text">
                  <span>
                    <span class="cursor-pointer text-400-semibold">{{ user.fullname }}</span>
                    <span class="cursor-pointer" v-if="tagUserItems.length > 0">
                      <span class="text-400-default"> cùng với </span>
                      <span class="cursor-pointer text-400-semibold"
                            @click="changeToTagUserPopup('to_tag_user')">{{ tagUserItems[0].fullname }}</span>
                      <span v-if="tagUserItems[1]">
                          <span class="text-400-default">, </span>
                          <span class="cursor-pointer text-400-semibold"
                                @click="changeToTagUserPopup('to_tag_user')">{{ tagUserItems[1].fullname }}</span>
                      </span>
                      <span v-if="tagUserItems.length > 2">
                        <span class="text-400-default"> và </span>
                        <span class="cursor-pointer text-400-semibold"
                              @click="changeToTagUserPopup('to_tag_user')">{{ tagUserItems.length - 2 }} người khác</span>
                      </span>
                    </span>
                  </span>
                  <p class="neutral_2 text-300-default mt-3 group-text">
                    <span v-if="selectedGroup == null">Tường cá nhân</span>
                    <span v-else>
                     <img class="bookmark" src="/img/modal/people.svg">
                     {{ selectedGroup.name }} - {{ selectedGroup.member_count }} thành viên</span>
                  </p>
                </div>
              </md-list-item>
              <div class="poll-container" v-if="isPoll">
                <div class="md-gutter">
                  <label class="required heading-400 neutral_2">Câu hỏi</label>
                  <input type="text" placeholder="Nhập câu hỏi" class="form-control input-custom mt-10px" name="name"
                         v-model="pollForm.question">
                </div>
                <div class="md-gutter mt-20px">
                  <label class="required heading-400 neutral_2">Thêm lựa chọn</label>
                  <div class="poll-option-wrapper">
                    <div class="poll-option mt-10px" v-for="(item, index) in pollForm.answers"
                         :key="'poll-option' + index">
                      <input v-model="pollForm.answers[index]" type="text" :placeholder="'Lựa chọn ' + (index + 1)"
                             class="form-control input-custom" required name="name">
                      <img class="remove-poll-option-btn cursor-pointer ml-5px" src="/img/modal/close.png"
                           v-if="pollForm.answers.length > 2" @click="deletePollOption(index)">
                    </div>
                  </div>
                </div>
                <button class="mt-10px add-option-btn text-400-medium" :disabled="pollForm.answers.length > 9"
                        @click="pollForm.answers.push('')">
                  <md-icon class="mr-5px">add</md-icon>
                  Thêm lựa chọn
                </button>
                <div class="mt-20px heading-400 neutral_2">Cài đặt</div>
                <div class="mt-10px">
                  <md-checkbox v-model="pollForm.multi_choice" class="md-success">Cho phép chọn nhiều câu trả lời
                  </md-checkbox>
                </div>
                <div>
                  <md-checkbox v-model="pollForm.is_add_option" class="md-success">Cho phép chọn thêm trả lời
                  </md-checkbox>
                </div>
                <div>
                  <md-checkbox @change="pollForm.expired_time = null" v-model="pollForm.time" class="md-success">Giới
                    hạn thời gian cho cuộc bình chọn
                  </md-checkbox>
                </div>
                <div class="poll-expired-time mt-20px pt-20px" v-show="pollForm.time">
                  <div class="heading-400 neutral_2">Kết thúc lúc</div>
                  <datetime type="datetime" v-model="pollForm.expired_time" format="dd-MM-yyyy hh:mm:ss"></datetime>
                </div>
                <button class="mt-20px poll-finish-btn" :disabled="disablePollCreateBtn"
                        @click="changeToPollPopup('create_poll')"><span style="margin: auto">Xong</span></button>
              </div>
              <div class="custom-scroll-bar-2" style="max-height: 500px; overflow-y: auto;" v-else>
                <div class="post-has-background__wrapper" v-if="postBackground && hasAllowedBackground"
                     :style="'background-image: url(' + postBackground.background_url + ')'">
                  <div class="post-has-background-input__wrapper">
                    <div class="post-has-background-input__main p-relative">
                      <div class="post-has-background-input__title" v-if="html_content === ''" :style="{'color': postBackground.color}">Bạn đang nghĩ gì?</div>
                      <div-editable v-model="html_content" :style="{'color': postBackground.color}"/>
                    </div>
                  </div>
                </div>
                <div class="p-relative" v-else>
                  <ckeditor v-model="html_content" @click="hiddenDialogEmoji" :config="editorConfig">
                  </ckeditor>
                  <img class="img-emoji" src="/img/post/footer/smile.png" @click="toogleDialogEmoji">
                  <VEmojiPicker class="p-absolute emoji" v-if="showDialogEmoji" @select="onSelectEmoji"
                                v-click-outside="hiddenDialogEmoji"/>
                </div>
                <div class="md-layout mt-15px p-relative">
                  <div class="background-list__wrapper" v-if="canShowBackgroundList">
                    <div class="background-item background_neutral_white" @click="postBackground = null"></div>
                    <div class="background-item" :style="'background-image: url(' + item.thumbnail.small_thumb + ')'"
                         v-for="(item, index) in postBackgroundImageList.slice(0, 12)" :key="'background-item' + index"
                         :class="{active: postBackground != null && postBackground.background_url === item.path}"
                         @click="selectPostBackground({'background_url': item.path, 'color': item.color})">
                    </div>
                    <div class="background-item" @click="isSelectingBackground = true">
                      <md-icon>apps</md-icon>
                    </div>
                  </div>
                  <div class="upload-btn-wrapper mr-15px" v-if="sharedPostData == null && !disableBackgroundBtn && pollData == null && this.file_ids.length == 0">
                    <button class="btn btn-background cursor-pointer" v-popover:tooltip.top="'Chọn ảnh nền'"
                            @click="canShowBackgroundList = !canShowBackgroundList">
                      <md-icon v-if="canShowBackgroundList">expand_less</md-icon>
                      <i class="md-icon md-icon-font md-theme-default background" v-else></i>
                    </button>
                  </div>
                  <div class="upload-btn-wrapper mr-15px" v-if="sharedPostData == null && postBackground == null">
                    <button class="btn btn-image cursor-pointer" :class="{'active': selectTypeUpload && selectTypeUpload === POST_TYPE.IMAGE,
                  'disabled': selectTypeUpload && (selectTypeUpload === POST_TYPE.FILE || selectTypeUpload === POST_TYPE.VIDEO)}"
                            v-popover:tooltip.top="'Thêm ảnh/video'">
                      <div class="btn-icon image cursor-pointer"></div>
                      <input type="file" class="custom-input cursor-pointer" name="files" multiple
                             :disabled="selectTypeUpload && selectTypeUpload === POST_TYPE.FILE && files.length > 0"
                             @click="selectUpload(POST_TYPE.IMAGE)"
                             @change="onFileChange"
                             accept="image/*,video/mp4,video/avi">
                    </button>
                  </div>
                  <div class="upload-btn-wrapper mr-15px"
                       v-if="sharedPostData == null && postBackground == null && selectedGroup !== null && selectedGroup !== ''"
                       v-popover:tooltip.top="'Thêm file'">
                    <button class="btn btn-file cursor-pointer" :class="{'active': selectTypeUpload && selectTypeUpload === POST_TYPE.FILE,
                  'disabled': selectTypeUpload && (selectTypeUpload === POST_TYPE.IMAGE || selectTypeUpload === POST_TYPE.VIDEO)}">
                      <div class="btn-icon file cursor-pointer"></div>
                      <input type="file" class="custom-input cursor-pointer"
                             :disabled="selectTypeUpload && selectTypeUpload === POST_TYPE.IMAGE && files.length > 0"
                             @click="selectUpload(POST_TYPE.FILE)"
                             name="files"
                             @change="onFileChange"
                             multiple
                             accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf">
                    </button>
                  </div>

                  <div class="upload-btn-wrapper mr-15px"
                       v-if="sharedPostData == null && postBackground == null && selectedGroup !== null && selectedGroup !== ''"
                       v-popover:tooltip.top="'Bình chọn'">
                    <button @click="changeToPollPopup('to_poll')" class="btn poll-btn cursor-pointer" :class="{'active': pollData != null,
                    'disabled': selectTypeUpload && (selectTypeUpload === POST_TYPE.IMAGE || selectTypeUpload === POST_TYPE.VIDEO || selectTypeUpload === POST_TYPE.FILE)}">
                      <div class="btn-icon poll cursor-pointer"></div>
                    </button>
                  </div>

                  <div class="upload-btn-wrapper" v-popover:tooltip.top="'Gắn thẻ đồng nghiệp'"
                       @click="changeToTagUserPopup('to_tag_user')">
                    <button class="btn poll-btn cursor-pointer" :class="{'active': this.isTagUser}">
                      <md-icon>sell</md-icon>
                    </button>
                  </div>
                </div>
                <poll-content v-if="pollData != null" :poll-data="pollData" :is-create-post-modal="true"
                              @update-poll="changeToPollPopup('update_poll')" @remove-poll="removePoll"></poll-content>
                <div v-if="sharedPostData" class="mt-20px">
                  <post-layout :post=sharedPostData :is-post-preview="true"></post-layout>
                </div>
                <div class="w_100">
                  <vue-element-loading :active="isLoadingLinkPreview" spinner="bar-fade-scale"/>
                  <link-metadata v-if="medias.length === 0 && linkMetadata" v-show="canShowLinkPreview"
                                 :link-metadata="linkMetadata" @close-link-preview="closeLinkPreview"/>
                </div>
                <div class="post-layout mt-15px" style="max-width: none">
                  <div class="post-content">
                    <vue-element-loading :active="loadingUploadFile" spinner="bar-fade-scale"/>
                    <md-card-content class="custom-scroll-bar-2">
                      <div class="image-content" @click="editImageContent"
                           v-if="selectTypeUpload && (selectTypeUpload === POST_TYPE.IMAGE || selectTypeUpload === POST_TYPE.ALBUM)">
                        <button class="edit-img-btn">
                          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"
                               class="mr-2">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M10.6462 1.31222C10.8415 1.11696 11.1581 1.11696 11.3534 1.31222L11.8819 1.84081C11.947 1.9059 12.0526 1.9059 12.1176 1.84081L12.6462 1.31222C12.8415 1.11696 13.1581 1.11696 13.3534 1.31222C13.5486 1.50748 13.5486 1.82406 13.3533 2.01932L12.8248 2.54792C12.7597 2.61301 12.7597 2.71854 12.8248 2.78362L13.3533 3.31222C13.5486 3.50748 13.5486 3.82406 13.3533 4.01933C13.1581 4.21459 12.8415 4.21459 12.6462 4.01932L12.1176 3.49073C12.0526 3.42564 11.947 3.42564 11.8819 3.49073L11.3533 4.01932C11.1581 4.21459 10.8415 4.21459 10.6462 4.01932C10.451 3.82406 10.451 3.50748 10.6462 3.31222L11.1748 2.78362C11.2399 2.71854 11.2399 2.61301 11.1748 2.54792L10.6462 2.01932C10.451 1.82406 10.451 1.50748 10.6462 1.31222ZM6.4998 1.91845C6.4998 1.64231 6.27594 1.41845 5.9998 1.41845C5.72365 1.41845 5.4998 1.64231 5.4998 1.91845V2.666C5.4998 2.75805 5.42518 2.83266 5.33313 2.83266L4.58558 2.83266C4.30944 2.83266 4.08558 3.05652 4.08558 3.33266C4.08558 3.60881 4.30944 3.83266 4.58558 3.83266L5.33313 3.83266C5.42518 3.83266 5.4998 3.90728 5.4998 3.99933V4.74688C5.4998 5.02302 5.72365 5.24688 5.9998 5.24688C6.27594 5.24688 6.4998 5.02302 6.4998 4.74688V3.99933C6.4998 3.90728 6.57442 3.83266 6.66646 3.83266H7.41401C7.69015 3.83266 7.91401 3.60881 7.91401 3.33266C7.91401 3.05652 7.69015 2.83266 7.41401 2.83266H6.66646C6.57442 2.83266 6.4998 2.75805 6.4998 2.666V1.91845ZM11.057 5.72276L10.9426 5.60838C10.4219 5.08768 9.57769 5.08768 9.05699 5.60838L8.13787 6.5275L10.1379 8.5275L11.057 7.60838C11.5777 7.08768 11.5777 6.24346 11.057 5.72276ZM1.60927 13.0561L7.19506 7.47031L9.19506 9.47031L3.60927 15.0561C3.08857 15.5768 2.24436 15.5768 1.72366 15.0561L1.60927 14.9417C1.08858 14.421 1.08857 13.5768 1.60927 13.0561ZM13.8331 9.25178C13.8331 8.97564 13.6093 8.75178 13.3331 8.75178C13.057 8.75178 12.8331 8.97564 12.8331 9.25178V9.99933C12.8331 10.0914 12.7585 10.166 12.6665 10.166H11.9189C11.6428 10.166 11.4189 10.3899 11.4189 10.666C11.4189 10.9421 11.6428 11.166 11.9189 11.166H12.6665C12.7585 11.166 12.8331 11.2406 12.8331 11.3327V12.0802C12.8331 12.3564 13.057 12.5802 13.3331 12.5802C13.6093 12.5802 13.8331 12.3564 13.8331 12.0802V11.3327C13.8331 11.2406 13.9078 11.166 13.9998 11.166H14.7473C15.0235 11.166 15.2473 10.9421 15.2473 10.666C15.2473 10.3899 15.0235 10.166 14.7473 10.166H13.9998C13.9078 10.166 13.8331 10.0914 13.8331 9.99933V9.25178Z"
                                  fill="white"></path>
                          </svg>
                          <span class="ml-5px">Sửa</span>
                        </button>
                        <image-content v-if="selectTypeUpload && selectTypeUpload === POST_TYPE.IMAGE"
                                       :mediaObject="{post_id: null, mediaList: medias, media_count: medias.length}"
                                       :isPostModal="true">
                        </image-content>
                      </div>
                      <file-content v-if="selectTypeUpload && selectTypeUpload === POST_TYPE.FILE"
                                    :files=medias :is-modal="true"></file-content>
                    </md-card-content>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </md-card-content>
        <md-dialog-actions v-if="this.selectedGroup != '' && !isPoll" class="p-15px w_100">
          <button type="submit" class="create-post-btn btn-active md-button w_100 text-400-medium"
                  :class="{'disabled': (html_content === '' && files.length == 0 && pollForm == null)}"
                  @click="createPost()">Tạo bài viết
          </button>
        </md-dialog-actions>
      </div>
      <edit-media-modal v-if="isEditingMedia"
                        :mediaEditList="medias"
                        @cancel-editing-media="isEditingMedia = false"
                        @confirm-editing-media="confirmEditingMedia"
      />
      <tag-user-modal :group="selectedGroup" :tag-user-items="tagUserItems" v-if="isTagUser"
                      @cancel-tag-user="isTagUser = false" @confirm-tag-user="handleTagUserForm"/>
      <select-post-background-modal v-if="isSelectingBackground"
                                    :background-image-list="postBackgroundImageList"
                                    :background-selected="postBackground"
                                    @cancel-selecting-background="isSelectingBackground = false"
                                    @select-post-background="selectPostBackground"/>
      <tooltip/>
    </modal>
  </div>
</template>

<script>
import {
  BRANCH_GROUP_TYPE,
  COMPANY_WALL_GROUP_TYPE,
  CREATE_POST_LEVEL,
  MODEL_TYPE,
  POST_TYPE,
  WORK_GROUP_TYPE
} from "../../../const/const";

import $ from "jquery";
import GroupService from "@/store/services/GroupService";
import PostService from "../../../store/services/PostService";
import ImageContent from "../Post/Content/ImageContent";
import FileContent from "../Post/Content/FileContent";
import {VEmojiPicker} from 'v-emoji-picker';
import {helpers} from "../../../helper/helpers";
import {Datetime} from 'vue-datetime';
import moment from 'moment';
import PollContent from "../Post/Content/PollContent";
import EditMediaModal from "./EditMediaModal";
import TagUserModal from "./TagUserModal";
import LinkMetadata from "../../Workplace/Pages/LinkMetadata";
import PostLayout from "../../Layout/Newfeed/PostLayout";
import SelectPostBackgroundModal from "./SelectPostBackgroundModal";
import DivEditable from "./DivEditable";
import SettingService from "../../../store/services/SettingService";

export default {
  name: 'create-post-modal',
  components: {
    EditMediaModal,
    ImageContent,
    FileContent,
    VEmojiPicker,
    datetime: Datetime,
    PollContent,
    TagUserModal,
    LinkMetadata,
    PostLayout,
    SelectPostBackgroundModal,
    DivEditable,
  },
  data() {
    return {
      workGroups: [],
      organizationGroups: [],
      joinedGroups: [],
      searchInput: "",
      groupImageDefault: '/img/group/group_image_low.jpg',
      selectedGroup: '',
      user: this.$store.state.auth.user,
      userPosition: this.$store.state.auth.userPosition,
      html_content: '',
      POST_TYPE: POST_TYPE,
      medias: [],
      selectTypeUpload: null,
      files: [],
      file_ids: [],
      file_urls: [],
      show: false,
      showDialogEmoji: false,
      router_name: this.$route.name,
      editorConfig: {
        toolbar: [
          ['Source'],
          ['Styles', 'Format', 'Font', 'FontSize'],
          ['Bold', 'Italic'],
          ['Undo', 'Redo'],
          ['Link'],
          ['numberedList', 'bulletedList']
          // [ 'About' ]
        ]
      },
      isPoll: false,
      pollForm: null,
      pollData: null,
      isUpdatePoll: false,
      loadingUploadFile: false,
      isTagUser: false,
      tagUserItems: [],
      isEditingMedia: false,
      linkMetadata: null,
      canShowLinkPreview: false,
      isLoadingLinkPreview: false,
      sharedPostData: null,
      isSelectingBackground: false,
      postBackground: null,
      canShowBackgroundList: false,
      postBackgroundImageList: [],
      disableBackgroundBtn: false,
      hasAllowedBackground: false,
    }
  },
  props: {
    postType: {
      type: String,
      default: POST_TYPE.TEXT
    },
  },
  mounted() {
    window.addEventListener("storage", this.storageListener);
    $('.poll-btn').hover(function (event) {
      $(".vue-popover").show();
    });
  },
  destroyed() {
    window.removeEventListener("storage", this.storageListener);
  },
  created() {

  },
  computed: {
    disablePollCreateBtn() {
      let answerSet = new Set();
      for (let i = 0; i < this.pollForm.answers.length; i++) {
        if (this.pollForm.answers[i].trim() == '') {
          return true;
        }
        answerSet.add(this.pollForm.answers[i].trim().toLowerCase());
      }

      if (answerSet.size != this.pollForm.answers.length) {
        return true;
      }

      if (this.pollForm.time) {
        if (this.pollForm.expired_time == null || this.pollForm.expired_time == '') {
          return true;
        }
      }

      return false;
    },
  },
  watch: {
    '$route'(to, from) {
      this.router_name = to.name
    },
    '$route.params.group_id'(to, from) {
      if (!to || !String(to).match(/^\d+$/)) {
        return;
      }
      this.getGroup();
    },
    html_content(newV) {
      if (this.file_ids.length !== 0) {
        return;
      }
      if (newV.length == 0) {
        return;
      }
      const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

      let urls = newV.match(urlRegex);

      if (urls && urls.length !== 0) {
        this.canShowLinkPreview = true;
        let url = urls[urls.length - 1].replace('&nbsp;&nbsp', '').replace('&nbsp', '');
        if (this.linkMetadata && url === this.linkMetadata.url) {
          return;
        }
        this.isLoadingLinkPreview = true;
        PostService.getLinkMetadata({url: url}).then(res => {
          this.isLoadingLinkPreview = false;
          this.linkMetadata = res.data;
          this.linkMetadata.url = url;
        });
      }
      if (this.postBackground && newV.length > 190) {
        this.hasAllowedBackground = false;
        this.canShowBackgroundList = false;
        this.disableBackgroundBtn = true;
      } else if (this.postBackground && newV.length < 190) {
        this.disableBackgroundBtn = false;
        this.hasAllowedBackground = true;
      }
    }
  },
  methods: {
    getGroups() {
      let param = {
        per_page: 25
      };
      if (this.searchInput) {
        param.keyword = this.searchInput;
      }
      GroupService.getGroups(param).then(res => {
        if (res && res.data.length !== 0) {
          let groups = res.data;
          let workGroups = [];
          let organizationGroups = [];
          let joinedGroups = [];
          for (let i = 0; i < groups.length; i++) {
            let group = groups[i];
            let typeNameAndColor = helpers.getGroupTypeNameAndColor(group.type);
            group.typeName = typeNameAndColor.typeName;
            group.classColor = typeNameAndColor.classColor;
            switch (group.type) {
              case WORK_GROUP_TYPE:
                workGroups.push(group);
                break;
              case COMPANY_WALL_GROUP_TYPE:
              case BRANCH_GROUP_TYPE:
                organizationGroups.push(group);
                break;
              default:
                joinedGroups.push(group);
            }
          }
          this.joinedGroups = joinedGroups;
          this.workGroups = workGroups;
          this.organizationGroups = organizationGroups;
        }
      });
    },

    selectGroup(type, group) {
      this.selectedGroup = group
    },

    beforeOpened(event) {
      if (this.$route.name == 'Group') {
        this.getGroup();
      } else {
        this.getGroups();
      }
      this.getPostBackgroundImageList();
      if (this.$route.name != 'Group') {
        if (this.$route.name != 'profile') {
          this.selectedGroup = '';
        } else {
          this.selectedGroup = null;
        }
      }
      ;
      this.isPoll = false;
      this.pollData = null;
      this.pollForm = null;
      this.isUpdatePoll = false;
      this.medias = [];
      this.files = [];
      this.html_content = [];
      this.tagUserItems = [];
      this.memberParams = {
        keyword: '',
        page: 1,
        last_page: 1,
      };
      this.linkMetadata = null;
      localStorage.setItem("create_post_modal_open", true);
      this.$store.commit("updateModalIsOpen", true);
      if (event.params.sharedPostId) {
        this.getPostDetail(event.params.sharedPostId);
      } else {
        this.sharedPostData = null;
      }
      this.isSelectingBackground = false;
      this.postBackground = null;
      this.hasAllowedBackground = false;
      this.canShowBackgroundList = false;
      this.disableBackgroundBtn = false;
    },

    beforeClosed() {
      localStorage.setItem("create_post_modal_open", false);
      this.$store.commit("updateModalIsOpen", false);
    },

    selectUpload(type) {
      if (this.files.length > 0) {
        return;
      }
      this.medias = [];
      this.selectTypeUpload = type;
    },

    removeFileUpload() {
      this.medias = [];
      this.files = [];
      this.selectTypeUpload = null;
    },

    async onFileChange(e) {
      let selectedFiles = e.target.files;
      let files = [];
      this.files = Object.values(e.target.files);
      await this.uploadFile();
      for (let i = 0; i < selectedFiles.length; i++) {
        files.push(selectedFiles[i]);
        // if (this.selectTypeUpload == POST_TYPE.FILE) {
        let item = {
          name: selectedFiles[i].name,
          file_size: selectedFiles[i].size,
          extension: selectedFiles[i].name.split('.').pop(),
          url: null,
          path: this.file_urls[i],
          id: this.file_ids[i]
        }
        this.medias.push(item);
      }
    },

    async uploadFile() {
      this.loadingUploadFile = true;
      if (this.files.length > 0) {
        this.file_ids = [];
        this.file_urls = [];
        const formFile = new FormData();

        for (let i = 0; i < this.files.length; i++) {
          formFile.append("files[]", this.files[i]);
        }

        await PostService.uploadFile(formFile).then(res => {
          if (res.status) {
            for (let i = 0; i < res.data.length; i++) {
              this.file_ids.push(res.data[i]['file_id'])
              this.file_urls.push(res.data[i]['url']);
            }
          }
          this.loadingUploadFile = false;
        });
      }
    },

    async createPost() {
      this.show = true;
      const formData = new FormData();
      let type = this.postType;

      if (this.selectTypeUpload && this.selectTypeUpload === POST_TYPE.IMAGE) {
        if (this.files.length == 1) {
          type = POST_TYPE.IMAGE;
        }
        if (this.files.length > 1) {
          type = POST_TYPE.ALBUM;
        }
      }

      if (this.selectTypeUpload && this.selectTypeUpload === POST_TYPE.FILE) {
        type = POST_TYPE.FILE;
      }

      // if (this.selectTypeUpload && this.selectTypeUpload === POST_TYPE.VIDEO) {
      //   type = POST_TYPE.VIDEO;
      // }

      let pollData = this.pollForm;
      if (this.pollForm != null) {
        if (this.pollForm.expired_time != '') {
          let date = new Date(this.pollForm.expired_time);
          this.pollForm.expired_time = moment(date).format('yyyy-MM-DD HH:mm:ss');
        }

        pollData = {
          "question": this.pollForm.question,
          "single_choice": !this.pollForm.multi_choice,
          "is_add_option": this.pollForm.is_add_option,
          "expired_time": this.pollForm.expired_time == '' ? null : this.pollForm.expired_time,
          "answers": this.pollForm.answers,
        };
      }

      let content = this.convertUrlContent(this.html_content);
      formData.append("html_content", content);
      formData.append("type", type);
      formData.append("level", CREATE_POST_LEVEL.POST);
      formData.append("model_type", this.selectedGroup === null ? MODEL_TYPE.USER : MODEL_TYPE.GROUP);
      formData.append("model_id", this.selectedGroup === null ? this.user.id : this.selectedGroup.id);
      formData.append("poll", JSON.stringify(pollData));
      formData.append("link_metadata", JSON.stringify(this.linkMetadata));
      this.tagUserItems.forEach(item => {
        formData.append("tags[]", item.id);
      })
      if (this.sharedPostData) {
        formData.append("shared_post_id", this.sharedPostData.post.id);
      }

      for (let i = 0; i < this.file_ids.length; i++) {
        formData.append("file_ids[]", this.file_ids[i]);
      }
      if (this.postBackground && this.hasAllowedBackground) {
        formData.append("background", JSON.stringify({"background_url": this.postBackground.background_url, "color": this.postBackground.color}))
      }

      await PostService.createPost(formData).then(res => {
        this.show = false;
        if (res.status) {
          this.$store.dispatch("alerts/success", 'Bạn tạo bài viết thành công.');
          this.$store.dispatch("getPost");
          this.$modal.hide('create-post-modal')
          this.$store.dispatch("changePostFlag", 1);
        }
      });
    },

    convertUrlContent(content) {
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

      let urls = urlRegex.exec(content);

      if (urls) {
        for (let i = 0; i <= urls.length; i++) {
          let url = '<p>' + urls[i] + '</p>'
          content = content.replace(url, '<p><a href="' + urls[i] + '">' + urls[i] + '</a></p>');
        }
      }
      content = this.removeWhiteLineFromTextContent(content);

      return content
    },

    removeWhiteLineFromTextContent(content) {
      let whiteLine = "\n<p>&nbsp;</p>\n";
      let lastOfContent = content.substring(content.length - 15, content.length);
      if (whiteLine == lastOfContent) {
        content = content.slice(0, -15);
        content = this.removeWhiteLineFromTextContent(content);
      }

      return content;
    },

    toogleDialogEmoji() {
      this.showDialogEmoji = !this.showDialogEmoji;
    },

    onSelectEmoji(emoji) {
      this.html_content += emoji.data;
    },

    hiddenDialogEmoji() {
      this.showDialogEmoji = false
    },

    getGroup() {
      const groupId = this.$route.params.group_id;
      if (!groupId || !String(groupId).match(/^\d+$/)) {
        return;
      }
      GroupService.getGroup({groupId: groupId}).then(res => {
        if (res && res.data) {
          this.selectedGroup = res.data
        }
      });
    },
    storageListener() {
      let index = localStorage.getItem("delete_file_index");
      if (index) {
        this.files.splice(index, 1);
        this.medias.splice(index, 1);
        localStorage.removeItem("delete_file_index");
      }
    },
    deletePollOption(index) {
      this.pollForm.answers.splice(index, 1);
    },
    removePoll() {
      this.pollForm = null;
      this.pollData = null;
    },
    changeToPollPopup(action) {
      if (this.selectTypeUpload && (this.selectTypeUpload === POST_TYPE.IMAGE || this.selectTypeUpload === POST_TYPE.VIDEO || this.selectTypeUpload === POST_TYPE.FILE)) {
        return;
      }
      if (action == 'cancel') {
        this.isPoll = false;
        if (!this.isUpdatePoll) {
          this.pollForm = null;
          this.pollData = null;
        }
      } else if (action == 'to_poll') {
        if (this.pollData != null) {
          return;
        }
        $(".vue-popover").hide();
        this.isPoll = true;
        this.pollForm = {
          answers: ['', ''],
          question: '',
          multi_choice: true,
          is_add_option: true,
          time: false,
          expired_time: null
        };
      } else if (action == 'create_poll') {
        this.isPoll = false;
        let options = [];
        for (let i = 0; i < this.pollForm.answers.length; i++) {
          let option = {
            "answer": this.pollForm.answers[i],
            "vote_ids": []
          };
          options.push(option);
        }
        this.pollData = {
          "question": this.pollForm.question,
          "single_choice": !this.pollForm.multi_choice,
          "is_add_option": this.pollForm.is_add_option,
          "expired_time": this.pollForm.expired_time == '' ? null : this.pollForm.expired_time,
          "data": options
        }
      } else if (action == 'update_poll') {
        this.isUpdatePoll = true;
        this.isPoll = true;
      }
    },
    changeToTagUserPopup(action) {
      if (action == 'to_tag_user') {
        this.isTagUser = true;
        $(".vue-popover").hide();
      }
    },
    handleTagUserForm(e) {
      this.tagUserItems = e;
      this.isTagUser = false;
    },
    editImageContent() {
      this.isEditingMedia = true;
    },
    confirmEditingMedia(e) {
      let mediaLatest = this.medias.filter(x => {
        return !e.includes(x.id);
      });
      let fileIdLatest = this.file_ids.filter(x => {
        return !e.includes(x);
      })
      this.medias = mediaLatest;
      this.file_ids = fileIdLatest;
      this.isEditingMedia = false;
    },
    closeLinkPreview() {
      this.linkMetadata = null;
      this.canShowLinkPreview = false;
    },
    getPostDetail(postId) {
      PostService.getPost({post_id: postId}).then(res => {
        if (res && res.data) {
          this.sharedPostData = res.data;
        }
      });
    },
    selectPostBackground(e) {
      this.postBackground = e;
      this.hasAllowedBackground = true;
      this.isSelectingBackground = false;
    },
    inputToPostHasBackground(event) {
      if (event.target.textContent !== this.html_content) {
        this.html_content = event.target.textContent;
      }
    },
    getPostBackgroundImageList() {
      SettingService.getPostBackgroundList().then(res => {
        if (res && res.data) {
          this.postBackgroundImageList = res.data
        }
      });
    }
  },
}

</script>

<style lang="scss">
.md-dialog {
  .md-dialog-container {
    width: 515px !important;
  }
}

.group-section {
  padding: 0 0 15px;
}

.select-group-modal .group-info-wrapper {
  height: auto;
  padding: 0 10px;
}

.select-group-modal .bookmark {
  height: 12px !important;
}

.image-content {
  position: relative;
}

.image-content .close-image {
  position: absolute;
  top: 20px;
  right: 20px;
  opacity: 0;
  font-size: 25px;
  color: #ffffff;
  z-index: 2;
  cursor: pointer;
}

.image-content:hover .close-image {
  opacity: 1;
}

.image-content .close-file {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 25px;
  color: #ffffff;
  z-index: 2;
  cursor: pointer;
}

.cke_bottom {
  display: none !important;
}

.cke_contents {
  height: 300px !important;
}

.select-group-modal .img-emoji {
  position: absolute;
  width: 22px !important;
  cursor: pointer;
  right: 10px;
  bottom: 10px;
}

.select-group-modal .emoji {
  top: 45px;
}

.select-group-modal .md-dialog-actions .create-post-btn {
  width: 100% !important;
}

.user-group-info {
  .md-list-item-text * {
    width: auto;
  }
}

.poll-container {
  .poll-option-wrapper {
    max-height: 350px;
    overflow-y: auto;

    .poll-option {
      display: flex;
      align-items: center;

      .remove-poll-option-btn {
        width: 20px;
        height: 20px;
      }
    }
  }

  .add-option-btn {
    cursor: pointer;
    text-align: center;
    background-color: rgb(207 228 255);
    font-weight: bold;
    display: flex;
    border-radius: 20px;
    height: 36px;
    width: 100%;
    border: none;
    align-items: center;
    justify-content: center;

    i {
      margin: initial;
    }
  }

  .md-checkbox {
    margin: initial;
  }

  .poll-finish-btn {
    cursor: pointer;
    height: 40px;
    width: 100%;
    border: none;
    border-radius: 10px;
    background-color: rgb(55, 84, 100);
    font-weight: bold;
    color: white;
  }

  .poll-finish-btn:disabled {
    background-color: rgb(200, 202, 207);
  }

  .poll-expired-time {
    border-top: 1px solid #D8DAE5;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .vdatetime-input {
      height: 30px;
    }
  }
}

.input-auto-complete {
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  border: none;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-align: center;
  align-items: center;
  max-height: 90px;
  overflow-y: auto;
  padding: 8px 12px;
  min-height: 58px;

  .item-select {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    height: 24px;
    margin: 5px;
    background-color: rgb(236, 247, 231);
    border: none;
    border-radius: 6px;
    box-sizing: content-box;
    padding: 4px 8px;
    outline: 0px;
    overflow: hidden;
    color: rgb(48, 169, 96);
    font-size: 12px;
    line-height: 16px;
    cursor: pointer;
    width: fit-content;

    .close-icon {
      display: flex;
      width: 16px;
      height: 16px;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      border: none;
      border-radius: 50%;
      background: white;
      color: rgba(0, 0, 0, 0.5);
      font-size: 16px;
      margin-left: 8px;
    }
  }
}

.cs-search-container {
  padding: 0 8px;

  .input-container {
    border-radius: 4px !important;
    padding-left: 10px !important;
    background-color: rgba(20, 33, 65, 0.06);
    border: 1px solid #e1e1e1;

    .md-icon {
      margin: auto !important;
    }
  }
}

.tag-user-container {
  .member-option {
    display: flex;
    border-top: 1px solid #efefef;
    cursor: pointer;
    justify-content: space-between;
  }

  .member-option:hover {
    background-color: rgba(20, 33, 65, 0.06);
  }

  .tag-form-button-wrapper {
    width: 100%;
    text-align: center;

    button {
      background-color: rgba(20, 33, 65, 0.06);
      border: none;
      width: 75px;
      height: 35px;
      cursor: pointer;
      border-radius: 8px;
    }
  }
}

.edit-img-btn {
  border: none;
  background: #5b53d9;
  border-radius: 8px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  height: 32px;
  left: 12px;
  line-height: 16px;
  min-width: 64px;
  padding: 8px 10px;
  position: absolute;
  top: 12px;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  z-index: 6;
}
</style>
